// Re-export shim for the api-backed referralService.

const ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
const randomChar = () => {
  const c = (typeof window !== 'undefined' && window.crypto) ? window.crypto : null;
  if (c && c.getRandomValues) {
    const arr = new Uint8Array(1);
    c.getRandomValues(arr);
    return ALPHABET[arr[0] % ALPHABET.length];
  }
  return ALPHABET[Math.floor(Math.random() * ALPHABET.length)];
};

export const generateReferralCode = (length = 6) => {
  let out = '';
  for (let i = 0; i < length; i += 1) out += randomChar();
  return out;
};

export const normaliseReferralCode = (raw) => {
  if (typeof raw !== 'string') return '';
  return raw.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
};

export const buildReferralLink = (origin, code) => {
  if (!origin || !code) return '';
  const o = origin.replace(/\/$/, '');
  return `${o}/signup?ref=${encodeURIComponent(code)}`;
};

export const copyToClipboard = async (text) => {
  if (typeof navigator === 'undefined' || !navigator.clipboard) return false;
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (_) {
    return false;
  }
};

export { referralService } from './referralServiceV2';
export { default } from './referralServiceV2';
